import { ReactElement } from 'react'
import { Box } from '@mui/material'
import { WasteStatus } from '@services/dtos'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import DeleteIcon from '@mui/icons-material/Delete'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'

const statusConfig: Record<WasteStatus, { color: 'success' | 'warning' | 'error'; icon: ReactElement }> = {
  [WasteStatus.OPEN]: { color: 'success', icon: <DeleteOutlineIcon fontSize="small" /> },
  [WasteStatus.CLOSED]: { color: 'warning', icon: <DeleteIcon fontSize="small" /> },
  [WasteStatus.DISPOSED]: { color: 'error', icon: <DeleteForeverIcon fontSize="small" /> },
}

type WasteStatusIconProps = {
  status: WasteStatus
}

const WasteStatusIcon = ({ status }: WasteStatusIconProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      color: `${statusConfig[status].color}.main`,
    }}
  >
    {statusConfig[status].icon}
  </Box>
)

export default WasteStatusIcon
